/**
 * RPS TAGS
 * Pure rule : to get a result, a respondent needs a minimum of tagged questions for each RPS dimension.
 * Source of truth : reporting-v2/app/application/apply_rps_by_users.py (DEFAULT_MIN_COUNTS).
 * Some surveys have their own minimums there on purpose (MIN_BY_SURVEY) : here it is only a warning.
 */

export const RPS_MIN_COUNTS: { [tag: string]: number } = {
  "decision-latitude": 2,
  "psychological-job-demands": 2,
  "skill-use": 1,
  "manager-support": 1,
  "team-support": 1,
  "work-gratitude": 1
}

interface RpsQuestion {
  draft?: boolean
  special?: string | null
  options?: { multipleItems?: boolean }
  Propositions?: { special?: string | null }[]
}

//Dimensions that do not have enough tagged questions. Nothing is reported if no question is tagged at all
//(the questionnaire is not an RPS one). Draft questions are not part of the questionnaire yet.
export function getRpsTagShortages(questions: RpsQuestion[]): { tag: string; count: number; min: number }[] {
  const counts: { [tag: string]: number } = {}
  let total = 0

  questions
    .filter((question) => !question.draft)
    .forEach((question) => {
      //Battery of items : each item carries its own tag
      const tags = question.options?.multipleItems
        ? (question.Propositions || []).map((proposition) => proposition.special)
        : [question.special]

      tags.forEach((tag) => {
        if (tag && RPS_MIN_COUNTS[tag]) {
          counts[tag] = (counts[tag] || 0) + 1
          total += 1
        }
      })
    })

  if (total === 0) return []

  return Object.keys(RPS_MIN_COUNTS)
    .filter((tag) => (counts[tag] || 0) < RPS_MIN_COUNTS[tag])
    .map((tag) => ({ tag, count: counts[tag] || 0, min: RPS_MIN_COUNTS[tag] }))
}
